import * as amplitude from "@amplitude/analytics-react-native"
import { SnackBarM } from "@common/components/alert/snackbar/SnackBar"
import IconButtonM from "@common/components/button/IconButtonM"
import * as Clipboard from "expo-clipboard"
import React, { useState, useEffect, useRef } from "react"
import { View } from "react-native"
import { Text, TextInput } from "react-native-paper"
import { theme } from "../../theme/theme"

const UncontrolledTextInputM = React.forwardRef((props, ref) => {
    const {
        password,
        name,
        errors,
        onChangeText,
        value,
        style = {},
        contentContainerStyle = {},
        copyPaste = false,
        disabled = false,
    } = props

    const [secure, setSecure] = React.useState(true)

    // Local state buffer to avoid cursor jump on mid-text edits
    const [localValue, setLocalValue] = useState(value ?? "")
    const isLocalEdit = useRef(false)

    useEffect(() => {
        if (!isLocalEdit.current) {
            setLocalValue(value ?? "")
        }
        isLocalEdit.current = false
    }, [value])

    return (
        <>
            <View
                style={{
                    width: "100%",
                    paddingVertical: props.multiline ? 10 : 0,
                    ...contentContainerStyle,
                }}
            >
                <TextInput
                    {...props}
                    ref={ref}
                    selectionColor={theme.colors.light}
                    mode="outlined"
                    outlineColor={theme.colors.light}
                    activeOutlineColor={theme.colors.light}
                    style={{
                        fontSize: 16,
                        width: "100%",
                        ...style,
                    }}
                    disabled={copyPaste || disabled}
                    value={localValue}
                    onChangeText={(text) => {
                        setLocalValue(text)
                        isLocalEdit.current = true
                        onChangeText?.(text)
                    }}
                    secureTextEntry={password && secure}
                    right={
                        password && (
                            <TextInput.Icon
                                color={theme.colors.primary}
                                icon={secure ? "eye" : "eye-slash"}
                                onPress={() => {
                                    setSecure(!secure)
                                }}
                            />
                        )
                    }
                    error={errors && errors[name]}
                />
                {errors && errors[name] && (
                    <Text
                        style={{
                            color: theme.colors.error,
                        }}
                    >
                        {errors[name].message}
                    </Text>
                )}
                {copyPaste && (
                    <IconButtonM
                        size={30}
                        icon={"copy"}
                        iconColor={theme.colors.primary}
                        style={{
                            position: "absolute",
                            right: 0,
                        }}
                        onPress={() => {
                            amplitude.track("button.clicked.copy-input")
                            Clipboard.setStringAsync(value).then(() => {
                                SnackBarM.show({
                                    text1: `📋 Copié dans le presse-papier`,
                                    duration: 6000,
                                })
                            })
                        }}
                    />
                )}
            </View>
        </>
    )
})

export default UncontrolledTextInputM
